export enum FacturationKind {
  SELF_MANAGED = "selfManaged",
  END_OF_MONTH = "endOfMonth",
}
